(() => {
  const setup = () => {
    const bar = document.querySelector('.wann-mobile-apply');
    const hero = document.querySelector('.nice-hero');
    const membership = document.getElementById('membership');
    if (!bar || !hero || !membership || !('IntersectionObserver' in window)) return;
    const mobile = window.matchMedia('(max-width: 760px)');
    const visible = new Set([hero]);
    const update = () => {
      const active = document.activeElement;
      const editing = active && active.matches('input, textarea, select, [contenteditable="true"]') && membership.contains(active);
      bar.hidden = !mobile.matches || visible.size > 0 || editing;
    };
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => entry.isIntersecting ? visible.add(entry.target) : visible.delete(entry.target));
      update();
    });
    observer.observe(hero);
    observer.observe(membership);
    const footer = document.querySelector('.wann-site-footer');
    if (footer) observer.observe(footer);
    mobile.addEventListener('change', update);
    document.addEventListener('focusin', update);
    document.addEventListener('focusout', () => requestAnimationFrame(update));
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup, {once:true});
  else setup();
})();
